/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190729 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { Resetable } from '../../resetter/resetable';
import { Archive } from 'src/app/_model/archive';

@Injectable()
export abstract class ArchivesDaoService implements Resetable {
  public abstract saveArchives(archives: Archive[]): Promise<void>;
  public abstract getArchives(): Promise<Archive[]>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
